module.exports = __webpack_public_path__ + "img/page.14a289ab.png";